import {deepClone} from "@/lib/utils";

export function isFilterApplied(filterModel, exceptions = []) {
  for (let i in filterModel) {
    if (!exceptions.includes(i) && i !== 'dateRange') {
      if (Array.isArray(filterModel[i])) {
        if (filterModel[i].length > 0) {
          return true
        }
      }
      else if (filterModel[i] || filterModel[i] === 0) {
        return true
      }
    }
  }
  return false
}

export default {
  isFilterApplied
}
